import { Grid } from '@mui/material';
import { validatePhoneNumber } from '@nx-smartmonkey/shared/helpers';
import { RoutalInputPhone, RoutalInputPhoneValue, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import { LoaderPage } from '../../../components/LoaderPage';
import { intl } from '../../../helpers/IntGlobalProvider';
import { useRetrieveSessionCountry } from '../../../hooks/session/useRetrieveSessionCountry';
import { Text } from '../../../react-components/Text';
import { useAuth } from '../hooks/useAuth';
import { useSessionGenerateOtp } from '../hooks/useSessionGenerateOtp';
import { StyledLoginButton } from './StyledLoginButton';

const formatPhoneNumber = (phone: string) => {
  const newPhone = phone.replace(/[^\d]+/g, ``);
  return `+${newPhone}`;
};

export const PhoneForm = ({ phone: initialPhone }: { phone?: string }) => {
  const [phone, setPhone] = useState<string>(initialPhone ?? ``);

  const { setAuthScreen } = useAuth();

  const { countryCode } = useRetrieveSessionCountry();

  const { run: generateOtp, success: otpGenerated, isLoading: isLoadingOtp } = useSessionGenerateOtp();

  const loginProcess = () => {
    generateOtp({
      phone: formatPhoneNumber(phone),
    });
  };

  useEffect(() => {
    if (otpGenerated) {
      console.log(`send code`);
      setAuthScreen(`login-otp`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpGenerated]);

  //Loading page para Auth
  if (isLoadingOtp) {
    return (
      <Grid style={{ display: `flex`, flexDirection: `column`, flexGrow: `1` }}>
        <LoaderPage />
      </Grid>
    );
  }

  const phoneValidation = validatePhoneNumber(formatPhoneNumber(phone));
  const isEnabled = !isLoadingOtp && phoneValidation;

  return (
    <Grid style={{ display: `flex`, flexDirection: `column`, flexGrow: `1` }}>
      <Grid item container flexDirection="column" alignItems="center" style={{ width: `100%` }}>
        <Text
          intlId="auth.phone_title"
          variant="h5"
          style={{ marginBottom: `24px`, textAlign: `center`, color: RoutalPalette.primary60 }}
        />
        <RoutalInputPhone
          countryCallingCodeEditable={false}
          focusInputOnCountrySelection
          international
          style={{
            width: `100%`,
          }}
          numberInputProps={{
            autoComplete: `off`,
            required: true,
            name: `phoneNumber`,
            style: {
              width: `100%`,
              height: `39px`,
              fontSize: `16px`,
              backgroundColor: RoutalPalette.white,
              borderColor: RoutalPalette.primary20,
            },
          }}
          placeholder={intl.formatMessage({ id: `auth.phone_ph` })}
          defaultCountry={countryCode}
          value={phone as RoutalInputPhoneValue}
          onChange={(value?: RoutalInputPhoneValue) => {
            setPhone(value ?? ``);
          }}
          inputFocusBorderColor={RoutalPalette.primary40}
          onKeyPress={(event: { key: string }) => {
            if (event.key === `Enter` && isEnabled) {
              loginProcess();
            }
          }}
        />
        <VSpacer />
        <Text intlId="auth.phone_subtitle" variant="body" style={{ marginBottom: `24px`, textAlign: `center` }} />
      </Grid>
      <Grid item style={{ width: `100%` }}>
        <StyledLoginButton
          disabled={!isEnabled}
          intlId="send"
          styleType="primary"
          isEnabled={isEnabled}
          onClick={() => {
            if (isEnabled) {
              loginProcess();
            }
          }}
        />
      </Grid>
    </Grid>
  );
};
